import type { LoginErrorReason } from '@sunflower-games/analytics-events';
import { FirebaseError } from 'firebase/app';

import { analytics } from '../../services/analytics';

const LOGIN_ERROR_REASONS: Record<string, LoginErrorReason> = {
  'auth/invalid-credential': 'invalid_credentials',
  'auth/wrong-password': 'invalid_credentials',
  'auth/user-not-found': 'email_not_found',
  'auth/network-request-failed': 'network',
};

/** `login_error` for a rejected email + password login; `errorMessage` is the text shown to the player. */
export function sendLoginError({
  error,
  forceReset,
  errorMessage,
}: {
  error: unknown;
  forceReset: boolean;
  errorMessage: string;
}) {
  const errorReason = forceReset
    ? 'force_reset_required'
    : (error instanceof FirebaseError && LOGIN_ERROR_REASONS[error.code]) || 'unknown';

  void analytics.sendEvent('login_error', {
    event_category: 'sign_up',
    event_action: 'impression',
    event_type: 'login_platform',
    event_value: 'email',
    status: 'failure',
    error_reason: errorReason,
    error_message: errorMessage,
  });
}

/** `reset_password_start` for a tap that opens the Reset Password screen from the login screen. */
export function sendResetPasswordStart(source: 'forgot_password' | 'force_reset_error') {
  void analytics.sendEvent(
    'reset_password_start',
    source === 'force_reset_error'
      ? {
          event_category: 'sign_up',
          event_action: 'click',
          event_type: 'reset_password_source',
          event_value: 'force_reset_error',
          button_text: 'reset password',
        }
      : {
          event_category: 'sign_up',
          event_action: 'click',
          event_type: 'reset_password_source',
          event_value: 'forgot_password',
          button_text: 'forgot password? click here',
        },
  );
}
